import _ from 'lodash';
import Chart from 'expose-loader?Chart!chart.js/dist/Chart.js';

import WaveSurfer from 'expose-loader?WaveSurfer!wavesurfer.js/dist/wavesurfer.min.js'; // eslint-disable-line no-unused-vars
import RegionsPlugin from 'expose-loader?RegionsPlugin!wavesurfer.js/dist/plugin/wavesurfer.regions.min.js'; // eslint-disable-line no-unused-vars
import ChartPlugin from 'expose-loader?ChartPlugin!src/components/specials/wavesurfer.chart.js';

import TimelinePlugin from 'expose-loader?TimelinePlugin!src/components/specials/wavesurfer.timeline.js'; // eslint-disable-line no-unused-vars
import videosurfer from 'videojs-wavesurfer/dist/videojs.wavesurfer.js'; // eslint-disable-line no-unused-vars
import videojs from 'video.js'; // eslint-disable-line no-unused-vars

export default {
  data() {
    return {
      wavesurferLoading: false, // Used to prevent multiple invocations of WS
      wavesurferLoaded: false,  // Use to register when WS is fully loaded
      currentTime: 0,
      totalTime: 0,
      containerSize: 0,
      player: null, // videojs player
      playing: false,
      maxMinPxPerSec: 160,
      wavesurferUrl: null,
      wavesurferResizeInterval: null,
    };
  },
  methods: {
    canZoomIn() {
      return this.wavesurferLoaded && this.wavesurfer.params.minPxPerSec < this.maxMinPxPerSec;
    },
    canZoomOut() {
      return this.wavesurferLoaded && this.wavesurfer.params.minPxPerSec > this.minPxPerSecForFit();
    },
    minPxPerSecForFit() {
      return this.wavesurferLoaded && this.containerSize / this.totalTime;
    },
    loadUrl() {
      this.totalTime = 0;
      this.wavesurferLoaded = false;
      this.wavesurfer.load(this.wavesurferUrl);
      this.wavesurfer.clearRegions();
    },
    wsTime(t) {
      const pad = (v) => {
        return _.padStart(Math.floor(v).toFixed(0), 2, '0');
      };

      if (t < 3600) {
        return `${pad(t / 60)}:${pad(t % 60)}`;
      }
      return `${pad(t / 3600)}:${pad((t / 60) % 60)}:${pad(t % 60)}`;
    },
    timeTenths(t) {
      const tenths = String(Math.floor(t * 10)).substr(-1);
      return `${this.wsTime(t)}.${tenths}`;
    },
    wsRecord(evt) {
      if (evt && evt.key && evt.key === 'Tab') {
        // Firefox bug fix
        return true;
      }
      this.$router.push({ name: 'record' });
    },
    wsPlay(evt) {
      if (evt && evt.key && evt.key === 'Tab') {
        // Firefox bug fix
        return true;
      }
      this.wavesurfer.play();
    },
    wsRestart(evt) {
      if (evt && evt.key && evt.key === 'Tab') {
        // Firefox bug fix
        return true;
      }
      this.wavesurfer.seekTo(0);
      this.updateControls();
    },
    wsPause(evt) {
      if (evt && evt.key && evt.key === 'Tab') {
        // Firefox bug fix
        return true;
      }
      this.wavesurfer.pause();
    },
    wsZoomIn(evt) {
      if (evt && evt.key && evt.key === 'Tab') {
        // Firefox bug fix
        return true;
      }
      this.wavesurfer.zoom(Math.min(this.wavesurfer.params.minPxPerSec * 2, 160));
      this.updateControls();
    },
    wsZoomOut(evt) {
      if (evt && evt.key && evt.key === 'Tab') {
        // Firefox bug fix
        return true;
      }
      this.wavesurfer.zoom(Math.max(this.wavesurfer.params.minPxPerSec / 2, this.minPxPerSecForFit()));
      this.updateControls();
    },
    wsZoomFit(evt) {
      if (evt && evt.key && evt.key === 'Tab') {
        // Firefox bug fix
        return true;
      }
      this.wavesurfer.zoom(this.minPxPerSecForFit());
      this.updateControls();
    },
    updateControls() {
      const wavesurferZoomIn = document.getElementById('wavesurferZoomIn'),
        //wavesurferZoomOut = document.getElementById('wavesurferZoomOut'),
        //wavesurferZoomFit = document.getElementById('wavesurferZoomFit'),
        wavesurferPlay = document.getElementById('wavesurferPlay'),
        wavesurferPause = document.getElementById('wavesurferPause');

      // Coherence check - Removed this when zoom controls turned off
      /*
      if (!wavesurferZoomIn) {
        return true;
      }
      */

      /* No longer showing these as disabled as it doesn't meet contrast requirements for a11y
      wavesurferZoomIn.className = (!canZoomIn()) ? 'wavesurferButton wavesurferDisabled' : 'wavesurferButton';

      if (!canZoomOut()) {
        wavesurferZoomOut.className = 'wavesurferButton wavesurferDisabled';
        wavesurferZoomFit.className = 'wavesurferButton wavesurferDisabled';
      } else {
        wavesurferZoomOut.className = 'wavesurferButton';
        wavesurferZoomFit.className = 'wavesurferButton';
      }
      */

      if (this.playing && wavesurferPlay) {
        wavesurferPlay.style.display = 'none';
        wavesurferPause.style.display = '';
      } else if (wavesurferPlay) {
        wavesurferPlay.style.display = '';
        wavesurferPause.style.display = 'none';
      }
    },

    keyboardControls(evt={}) {
      if (evt.key === 'p' || evt.key === 'P') {
        if (this.playing) {
          this.wsPause();;
        } else {
          this.wsPlay();
        }
      } if (evt.key === 'r' || evt.key === 'R') {
        this.wavesurfer.skipBackward();
      } if (evt.key === 'f' || evt.key === 'F') {
        this.wavesurfer.skipForward();
      }
    },

    /**
     * Call this to render wavesurfer. It will not fire if WS is in the process of loading already.
     * @param permitRerender This lets WS be updated for conversational speech
     * @returns {boolean}
     */
    loadWavesurfer(permitRerender= false) {
      if (!this.recording || !this.recording.recordingId) return false;

      if (!document.getElementById('wavesurferContainer')) {
        // If we don't have wavesurfer, make sure to remove the video as well
        this.reset();
        return false;
      }
      if (!this.recording.isVideo && !this.recording.playbackUrl) {
        return false;
      }

      // Dont let us load WS twice
      if (this.wavesurferLoading) {
        return false;
      }

      // Dont rerender the same recording
      if (!permitRerender && this.renderedWavesurfer === this.recording.recordingId) {
        // Don't re-render the same recording.
        return true;
      }

      // Actually add wavesurfer
      this.wavesurferLoading = true;

      try {
        this.reset();
        this._loadWavesurfer();
      } catch (err) {
        this.$store.dispatch('notify', {
          type: 'error',
          subject: 'Display Error',
          text: (this.isIe) ? `You appear to be using Internet Explorer.<br><br>
              This browser does not support all the audio features needed for a full experience.
              As a result, the recording below was not able to render properly.
              Please use Microsoft Edge, Chrome or Firefox instead.` :
            `There was an error while displaying your recording below. Please reload the page or
              try using a different browser.`
        });
        throw new Error(err);
      }

      // Mark it completed
      this.renderedWavesurfer = this.recording.recordingId;
    },

    _loadWavesurfer() {
      this.wavesurferUrl = this.recording.playbackUrl;
      const supportedPlugins = ['Regions', 'Timeline', 'Chart'];

      /* Initialize Wavesurfer */
      const plugins = [];
      const config = {
        wavesurferTimeline: {
          container: '#wavesurferTimeline',
          fontFamily: 'Open Sans',
          primaryColor: '#333333',
          primaryFontColor: '#333333',
          secondaryColor: '#333333',
          secondaryFontColor: '#333333',
          notchPercentHeight: 0,
          labelPadding: 2,
          formatTimeCallback: this.wsTime,
        },
      };

      supportedPlugins.forEach((plugin) => {
        const pluginLower = plugin.toLowerCase();
        const constructorModule = (window.WaveSurfer[pluginLower]) ?
          window.WaveSurfer[pluginLower] : window[plugin + 'Plugin'];
        const constructor = ('default' in constructorModule) ?
          constructorModule.default : constructorModule;

        if (config['wavesurfer' + plugin]) {
          plugins.push(constructor.create(config['wavesurfer' + plugin]));
        } else {
          plugins.push(constructor.create());
        }
      });

      const wavesurferArgs = {
        container: document.getElementById('wavesurferContainerInternal'),
        waveColor: '#666666',
        progressColor: 'rgb(49, 142, 187, 0.2)',
        cursorColor: '#318EBB',
        normalize: true,
        pixelRatio: 2,
        splitChannels: !!(this.wavesurferUrl.indexOf('multichannel') !== -1),
        src: this.wavesurferUrl,
        plugins,
      };

      // A breakdown on Wavesurfer's 3 backends:
      // 1) WebAudio will not play 3+ speaker audio -- Anything other than speaker 1/2 is muted
      // 2) MediaElementWebAudio has all kinds of CORS issues, see https://github.com/katspaugh/wavesurfer.js/issues/2116
      // it also stutters in Safari, even if you manage to get it working.
      // 3) MediaElement can play 3+ speaker audio, except in Safari where MediaElement functions the
      // same as "WebAudio" (i.e., Speakers 3/4/5 are muted)
      // Also, we need MediaElement for iOS Safari when video is on, or Wavesurfer doesnt render
      // const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent || '') ||
      //  /iPad|iPhone|iPod/i.test(navigator.userAgent || '');
      const isMultiSpeaker = (this.recording.results && this.recording.results.scores &&
        this.recording.results.scores.numSpeakers && this.recording.results.scores.numSpeakers > 2) ? true : false;
      if (isMultiSpeaker) {
        wavesurferArgs.backend = 'MediaElement';
      }

      if (this.isVideo && this.hasVideoPlaybackData) {
        // configuration for video.js
        let options = {
          debug: true,
          controls: true,
          bigPlayButton: true,
          autoplay: false,
          loop: false,
          fill: false,
          fluid: true,
          plugins: {
            // enable videojs-wavesurfer plugin
            wavesurfer: wavesurferArgs,
          }
        };

        this.player = videojs('videoPlayer', options, () => {
          this.player.src({src: this.recording.videoUrl, type: 'video/mp4'});

          this.player.on('waveReady', () => {
            this.wavesurfer = this.player.wavesurfer().surfer;
            this.addWavesurferEvents(); // registers wavesurfer.ready event
            this.$emit('update:wavesurfer', this.wavesurfer);

            // Videojs.Wavesurfer registers a function that destroys Wavesurfer
            // when the window is resized. This removes any active regions. Since
            // we don't want this, we patch out the function.
            this.player.wavesurfer().redrawWaveform = () => { };

            // Manually call wavesurferReady and Seek cuz the events got skipped
            this.wavesurferReady();
            this.wavesurferSeek();

            // Manually call handleResize() to correctly position VideoJs
            window.setTimeout(this.handleResize, 1000);
          });
        });
      } else {
        this.wavesurfer = window.WaveSurfer.create(wavesurferArgs);
        this.$emit('update:wavesurfer', this.wavesurfer);
        this.addWavesurferEvents();
        this.loadUrl();
      }
    },

    reset() {
      this.currentTime = 0;
      window.wavesurferIsPlaying = false;
      this.playing = false;

      // Remove all tippys
      if (window.registeredTippys && window.registeredTippys.length) {
        window.registeredTippys.forEach((tp) => tp.hide());
      }
      window.registeredTippys = [];

      // Prevent weird race conditions caused by "Extracting audio" status recordings
      this.renderedWavesurfer = null;
      this.wavesurferUrl = null;

      // Try/Catch allows us to safely call wavesurfer.destroy() when it doesn't yet exist
      if (document.getElementById('wavesurferContainerInternal')) {
        document.getElementById('wavesurferContainerInternal').innerHTML = '';
      }

      // Hide or show the video element. This can't be done with Vue since it's created by video-js
      const vP = document.getElementById('videoPlayer');
      const renderingVideo = (this.recording && this.recording.videoUrl && this.isVideo);
      const initialLoad = (vP && 'video' === vP.nodeName.toLowerCase());

      // First, clear out videoPlayer, if it exists
      if (this.player) {
        this.player.dispose();
        this.player = null;
      }

      if (renderingVideo && initialLoad) {
        // If we are rendering video with the initial load, everything is fine
      } else {
        if (vP) vP.remove();

        // Second, restore <video> if we are rendering video
        if (renderingVideo && document.getElementById('videoPlayerContainer')) {
          document.getElementById('videoPlayerContainer').innerHTML =
            '<video id="videoPlayer" class="video-js vjs-default-skin" playsinline />';
        } else if (document.getElementById('videoPlayerContainer')) {
          // Otherwise, remove it
          document.getElementById('videoPlayerContainer').innerHTML = '';
        }
      }

      if (this.wavesurfer) {
        clearInterval(this.wavesurferResizeInterval);
        this.wavesurfer.pause();
        try {
          delete this.wavesurfer.backend.buffer;
          this.wavesurfer.destroy();
        } catch(err) { void(0); }
        this.wavesurfer = null;
        this.wavesurferResizeInterval = null;
      }
    },

    wavesurferReady() {
      if (!this.wavesurfer || !this.wavesurfer.container) {
        return;
      }
      this.currentTime = 0;
      this.wavesurferLoaded = true;
      this.totalTime = this.wavesurfer.getDuration();
      this.containerSize = this.wavesurfer.container.clientWidth;
      if (document.getElementById('wavesurferTotalTime')) {
        document.getElementById('wavesurferTotalTime').innerHTML = this.timeTenths(this.totalTime);
      }
      this.updateControls();
    },

    wavesurferSeek() {
      this.currentTime = this.wavesurfer.getCurrentTime();
      if (document.getElementById('wavesurferCurrentTime')) {
        document.getElementById('wavesurferCurrentTime').innerHTML = this.timeTenths(this.currentTime);
      }
    },

    addWavesurferEvents() {
      this.wavesurfer.on('ready', this.wavesurferReady);

      this.wavesurfer.on('audioprocess', _.throttle(time => {
        this.currentTime = time;
        if (document.getElementById('wavesurferCurrentTime')) {
          document.getElementById('wavesurferCurrentTime').innerHTML = this.timeTenths(this.currentTime);
        }
      }, 100));

      this.wavesurfer.on('seek', this.wavesurferSeek);

      this.wavesurfer.on('play', () => {
        window.wavesurferIsPlaying = true;
        this.playing = true;
        this.updateControls();
      });
      this.wavesurfer.on('pause', () => {
        window.wavesurferIsPlaying = false;
        this.playing = false;
        this.updateControls();
      });
      this.wavesurfer.on('finish', () => {
        this.wavesurfer.seekTo(1);
        this.wavesurfer.seekTo(0);
        window.wavesurferIsPlaying = false;
        this.playing = false;
        this.updateControls();
      });

      this.wavesurferResizeInterval = setInterval(() => {
        if (!this.wavesurferLoaded || this.containerSize == this.wavesurfer.container.clientWidth || !this.wavesurfer.container) {
          return;
        }
        this.containerSize = this.wavesurfer.container.clientWidth;
        this.wavesurfer.empty();
        try {
          this.wavesurfer.drawBuffer(); // This throws an error in timeline plugin
        } catch(e) { }
      }, 1000);


      // We need to delay this slightly because videojs fires twice when loading in processing recordings
      // TODO: Is there a better way to fix this?
      window.setTimeout(() => this.wavesurferLoading = false, 250);
    },
  }
};